import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { matchesRoute } from '@dtx-company/true-common/src/utils/urls/matchesRoute'
import { usePathname } from 'next/navigation'
import { useRouter } from 'next/router'

export function usePageTemplateEditorState(): { isTemplateEditor: boolean; templateId?: string } {
  const pathname = usePathname() ?? ''
  const router = useRouter()
  const isTemplateEditor = matchesRoute(pathname, Routes.PAGE_TEMPLATE_EDITOR)
  const queryId = Array.isArray(router.query.id) ? router.query.id[0] : router.query.id
  return {
    isTemplateEditor,
    templateId: isTemplateEditor ? queryId : undefined
  }
}
